export default {
  interview: {
    interviewLocations: "v1/interview_location",
    interviewLocation: "v1/interview_location/{0}",
    interviewLocationPlans: "v1/interview-location-plan",
    interviewLocationPlan: "v1/interview-location-plan/{0}",
    interviewLocationPlanDetail: "v1/interview-location-plan/{0}/detail",
    interviewLocationSchedules: "v1/interview_location/{0}/plan",
    interviewLocationPersons: "v1/interview_location_person",
    interviewLocationPerson: "v1/interview_location_person/{0}",
    interviewLocationAudiences: "v1/interview-location-plan/{0}/audiences",
    interviewLocationMasters: "v1/interview-location-plan/{0}/masters",
    interviewAccepting: "v1/interview_accepting/{0}",
    interviewAcceptingAttachments: "v1/fa/interview/attachment-interview/{0}",
    interviewAcceptingAttachment:
      "v1/fa/interview/attachment-interview/{0}/attachment/{1}",
    interviewDoing: "v1/interview_doing/{0}",
    interviewDoingAttachments: "v1/fa/interview/attachment-interview-done/{0}",
    interviewDoingAttachment:
      "v1/fa/interview/attachment-interview-done/{0}/attachment/{1}",
    interviewDoneAttachment: "v1/interview_done_attachment/{0}",
    interviewDone: "v1/interview_done",
    interviewDoneId: "v1/interview_done/{0}",
    interviewPlaningShow: "v1/interview_planing_show",
    interviewReady: "v1/interview-ready",
    importInterviewLocationPerson: "v1/import-interview-location-person",
    importInterviewFinalResult: "v1/import-interview-final-result",
    interviewFinalResult: "v1/interview-final-result",
    parvandehInterviewFinalResult: "v1/parvandeh/{0}/interview-final-result",
    parvandehInterviewQueue: "v1/parvandeh/{0}/interview-queue",
    parvandehInterviewDone: "v1/parvandeh/{0}/interview-done",
  },
};
